import { EGarageUtility, NonEmptyArray } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectGarageUtilitiesFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const GarageUtilitiesContainer: FC = () => {
  const { label, value, options } = useSelector(selectGarageUtilitiesFilter);

  const onChange = useFilterChangeCallback();

  const handleGarageUtilitiesChange = useCallback(
    (newValue: NonEmptyArray<EGarageUtility> | null) => {
      onChange({ action: 'setGarageUtilities', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter options={options} value={value} onFilterChange={handleGarageUtilitiesChange} />
    </AdvancedFilterRow>
  );
};
